// removed by extract-text-webpack-plugin
module.exports = {"creditCardPayment":"nia-e","installmentsWrap":"_3d9CL"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/CreditCard/CreditCard.scss
// module id = 208
// module chunks = 0 1